import { StrictMode } from 'react'
import { hydrateRoot, type Root } from 'react-dom/client'

import { App } from './app.tsx'
import { resolveRoute } from './routes.ts'

/**
 * Attaches React to the prerendered markup already present in `container`.
 *
 * Hydration, never client rendering: the document is complete before JavaScript
 * arrives, so LCP is decided by HTML and CSS alone and CLS stays at 0.0.
 */
export function bootstrap(container: Element, pathname: string): Root {
  return hydrateRoot(
    container,
    <StrictMode>
      <App route={resolveRoute(pathname)} />
    </StrictMode>,
  )
}
